import i18n from 'i18n';
import * as Yup from 'yup';

export default () => {
  return Yup.object().shape({
    replace_instances: Yup.object().shape({
      block_users_message: Yup.string().when('block_users', {
        is: true,
        then: Yup.string()
          .required(i18n.t('REQUIRED_FIELD_KEY'))
          .nullable(true),
        otherwise: Yup.string().nullable(true),
      }),
      block_users_seconds: Yup.number().when('block_users', {
        is: true,
        then: Yup.number()
          .required(i18n.t('REQUIRED_FIELD_KEY'))
          .nullable(true),
        otherwise: Yup.number().nullable(true),
      }),
    }),
  });
};
